import React, { useState } from 'react';
import { submitAccessRequest } from '../utils/api';
import './RequestAccessModal.css';

const RequestAccessModal = ({ isOpen, onClose }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    relationship: '',
    message: ''
  });
  const [submitting, setSubmitting] = useState(false);
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSubmitting(true);
    
    try {
      await submitAccessRequest(formData);
      setSubmitted(true);
    } catch (err) {
      console.error('Submit error:', err);
      setError('Failed to submit request. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  const handleClose = () => {
    setFormData({ name: '', email: '', relationship: '', message: '' });
    setSubmitted(false);
    setError('');
    onClose();
  };

  if (!isOpen) return null;

  return (
    <div className="request-access-overlay" onClick={handleClose}>
      <div className="request-access-content" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={handleClose}>×</button>
        
        {!submitted ? (
          <>
            <h2>Request Access</h2>
            <p className="modal-subtitle">
              Share who you are so the family can grant you access.
            </p>

            <form onSubmit={handleSubmit}>
              <div className="form-group">
                <label>Your Name *</label>
                <input
                  type="text"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  placeholder="Your full name"
                  required
                  disabled={submitting}
                />
              </div>

              <div className="form-group">
                <label>Email Address *</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="your.email@example.com"
                  required
                  disabled={submitting}
                />
              </div>

              <div className="form-group">
                <label>Your Relationship to Jeffrey or His Family *</label>
                <input
                  type="text"
                  name="relationship"
                  value={formData.relationship}
                  onChange={handleChange}
                  placeholder="e.g., I knew Jeff at Thornhill Elementary"
                  required
                  disabled={submitting}
                />
              </div>

              <div className="form-group">
                <label>Message (Optional)</label>
                <textarea
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="We'd love to hear any thoughts you'd like to share..."
                  rows="4"
                  disabled={submitting}
                />
              </div>

              <p className="modal-subtitle">
                <strong>Thank you in advance</strong> for helping keep Junior Stones safe in Jeffrey's memory.  Please invite others to join.
              </p>

              {error && (
                <div className="error-message">
                  {error}
                </div>
              )}

              <button 
                type="submit" 
                className="submit-button"
                disabled={submitting}
              >
                {submitting ? 'Submitting...' : 'Submit Request'}
              </button>
            </form>
          </>
        ) : (
          <div className="success-message">
            <h2>Thank You!</h2>
            <p>
              Your request has been submitted. Jeffrey's family will review it and get back to you soon at <strong>{formData.email}</strong>.
            </p>
            <p>
              You'll receive an email with login instructions once your access is approved.
            </p>
            <button onClick={handleClose} className="close-button">
              Close
            </button>
          </div>
        )}
      </div>
    </div>
  );
};

export default RequestAccessModal;